import React from 'react';

interface TableProps {
  children: React.ReactNode;
  className?: string;
}

export const Table: React.FC<TableProps> = ({ children, className = '' }) => {
  return (
    <div className="overflow-x-auto rounded-xl border border-neutral-200/60 bg-white shadow-card">
      <table className={`min-w-full divide-y divide-neutral-200/60 ${className}`}>
        {children}
      </table>
    </div>
  );
};

export const TableHeader: React.FC<TableProps> = ({ children }) => {
  return <thead className="bg-gradient-to-r from-neutral-50 to-neutral-100/50">{children}</thead>;
};

export const TableBody: React.FC<TableProps> = ({ children }) => {
  return <tbody className="bg-white divide-y divide-neutral-100">{children}</tbody>;
};

export const TableRow: React.FC<TableProps> = ({ children, className = '' }) => {
  return <tr className={`hover:bg-primary-50/30 transition-colors duration-150 ${className}`}>{children}</tr>;
};

export const TableHead: React.FC<TableProps> = ({ children, className = '' }) => {
  return (
    <th className={`px-3 sm:px-6 py-3 sm:py-4 text-left text-[10px] sm:text-xs font-semibold text-neutral-500 uppercase tracking-wider ${className}`}>
      {children}
    </th>
  );
};

interface TableCellProps extends TableProps {
  colSpan?: number;
  rowSpan?: number;
}

export const TableCell: React.FC<TableCellProps> = ({ children, className = '', colSpan, rowSpan }) => {
  return (
    <td 
      className={`px-3 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm text-neutral-700 ${className}`}
      colSpan={colSpan}
      rowSpan={rowSpan}
    >
      {children}
    </td>
  );
};
